/* ============================================================
   RAVUMI — otwieranie Instagrama w aplikacji na telefonie.

   Zasada dzialania: na urzadzeniu mobilnym probujemy uruchomic
   schemat "instagram://", ktory przechwytuje aplikacja. Jesli
   aplikacji nie ma, nic sie nie dzieje i po krotkiej chwili
   przechodzimy na zwykly adres www — uzytkownik nigdy nie
   zostaje z pusta strona.

   Na komputerze nie robimy nic: link dziala normalnie.
   ============================================================ */

(function () {
  'use strict';

  var MOBILE = /android|iphone|ipad|ipod/i.test(navigator.userAgent);
  if (!MOBILE) return; // desktop — zostawiamy zwykly link

  function openInApp(event) {
    var link = event.currentTarget;
    var handle = link.getAttribute('data-ravumi-instagram');
    if (!handle) return;

    event.preventDefault();

    var webUrl = 'https://www.instagram.com/' + handle + '/';
    var appUrl = 'instagram://user?username=' + handle;
    var switched = false;

    // Jesli aplikacja przejmie kontrole, karta traci widocznosc —
    // wtedy anulujemy zaplanowane przejscie do przegladarki.
    function onHide() {
      if (document.hidden) switched = true;
    }
    document.addEventListener('visibilitychange', onHide);

    // Proba uruchomienia aplikacji
    window.location.href = appUrl;

    // Zabezpieczenie: brak aplikacji → otwieramy strone www
    window.setTimeout(function () {
      document.removeEventListener('visibilitychange', onHide);
      if (!switched && !document.hidden) {
        window.location.href = webUrl;
      }
    }, 700);
  }

  function bind() {
    var links = document.querySelectorAll('[data-ravumi-instagram]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', openInApp);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
